import {
  Box,
  Button,
  Checkbox,
  Grid,
  FormGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { toast } from "react-hot-toast";
import PageHeader from "../components/ui/PageHeader";
import CustomInput from "../components/ui/CustomInput";
import DownloadExcelModal from "../components/Modals/DownloadExcelModal";

import { useRef, useState, useEffect } from "react";
import PageForm from "../components/ui/PageForm";
import DownloadIcon from "@mui/icons-material/Download";

import { useLoading } from "../components/LoadingContext";
import {
  handleError,
  errorToast,
  getFilledOrNullString,
  getDateAsISOString,
  getFilledOrEmptyArray
} from "../services/serviceBase";
import { useIntl } from "react-intl";

import {
  getExcelReports,
  runReportDownload,
} from "../services/exportService";
import * as apiService from "../services/apiService";

const FASTExtractions = () => {
  const intl = useIntl();
  const { setLoading } = useLoading();

  const [dossierKey, setDossierKey] = useState('');
  const [ict, setIct] = useState('');
  const [invoice, setInvoice] = useState('');
  const [sapInboundDelivery, setSapInboundDelivery] = useState('');

  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [downloadLink, setDownloadLink] = useState("");
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isInError, setIsInError] = useState(false);
  const [tableHeigth, setTableHeigth] = useState(260);
  const [report, setReport] = useState(null);
  const [fieldSet, setFieldSet] = useState(null);

  const [year, setYear] = useState(null);
  const [number, setNumber] = useState(null);
  const [split, setSplit] = useState(null);
  const [vendorNumber, setVendorNumber] = useState('');
  const [departments, setDepartments] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const messageId = useRef();

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - fromHeight - 400;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  const handletrasitionEnd = () => {
    resizeTable();
  };

  const getCompanyList = async () => {
    apiService.getCompanies(
      (response) => {
        setLoading(false);
        var selectCompanyItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectCompanyItems.push({
              value: x.idCompany,
              text: x.companyDescription,
            });
          });
        }
        setCompanies(selectCompanyItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  useEffect(() => {
    getCompanyList();
    getReports();
    getDepartments();
  }, []);

  const getReports = async () => {
    setLoading(true);
    getExcelReports(
      "FAST",
      (response) => {
        setLoading(false);
        if (response.length != 1) {
          toast.error("Error in report configuration");
          return;
        }
        setReport(response[0].idExcelReport);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const handleRun = () => {
    var data = {
      IdExcelReportFieldSet: getFilledOrNullString(fieldSet?.idExcelReportFieldSet),
      IdCompanyList: getFilledOrEmptyArray(selectedCompanies),
      IdRFDepartmentList: getFilledOrEmptyArray(selectedDepartments),
      InError: isInError,
      DateFrom: getDateAsISOString(fromDate),
      DateTo: getDateAsISOString(toDate),
      ICT: getFilledOrNullString(ict),
      Invoice: getFilledOrNullString(invoice),
      SapInboundDelivery: getFilledOrNullString(
        sapInboundDelivery
      ),
      RFYear: getFilledOrNullString(year),
      RFNumber: getFilledOrNullString(number),
      RFSplit: getFilledOrNullString(split),
      VendorNumber: getFilledOrNullString(vendorNumber),
    };

    setLoading(true);

    runReportDownload(
      report,
      data,
      (response) => {
        setLoading(false);
        setDownloadLink(response);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  const getDepartments = async () => {
      setLoading(true);
      apiService.getDepartments(
        (response) => {
          setLoading(false);
          var selectDepartmentItems = [];
          if (response !== undefined) {
            response.map((x) => {
              selectDepartmentItems.push({
                value: x.departmentCode,
                text: x.departmentCode + " - " + x.departmentName,
              });
            });
          }
          setDepartments(selectDepartmentItems);
        },
        (error) => {
          setLoading(false);
          handleError(error, intl);
        }
      );
    };

  const handleCheckBoxChange = (event) => {
    setIsInError(event.target.checked);
  };

  return (
    <Box>
      <PageHeader title={intl.formatMessage({ id: "FASTExtractions.Title" })} />

      <Box sx={{ mt: 0.5 }}>
        <PageForm
          adjustHeightFunc={handletrasitionEnd}
          form={
            <form>
              <Grid container spacing={2}>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Brand" })}
                    type="multiselect"
                    value={selectedCompanies}
                    selectItems={companies}
                    setValue={setSelectedCompanies}
                    inputCol={10}
                    textCol={2}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "TKExcelReports.VendorNumber",
                    })}
                    type="text"
                    value={vendorNumber}
                    setValue={setVendorNumber}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "TKExcelReports.SapInboundDelivery",
                    })}
                    type="text"
                    value={sapInboundDelivery}
                    setValue={setSapInboundDelivery}
                    inputCol={6}
                    textCol={6}
                  />
                </Grid>
                <Grid item md={1}>
                  <Typography mt={1} sx={{color: "rgba(0, 0, 0, 0.6)"}}>Dossier:</Typography>
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Year" })}
                    type="number"
                    value={year}
                    setValue={setYear}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Department" })}
                    type="multiselect"
                    valueRef={selectedDepartments}
                    selectItems={departments}
                    setValue={setSelectedDepartments}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item md={3}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Number" })}
                    type="number"
                    value={number}
                    setValue={setNumber}
                    inputCol={8}
                    textCol={4}
                  />
                </Grid>
                <Grid item md={2}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "TKExcelReports.Split" })}
                    type="number"
                    value={split}
                    setValue={setSplit}
                    inputCol={7}
                    textCol={5}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "RASearch.FromDate",
                    })}
                    type="date"
                    valueRef={fromDate}
                    setValue={setFromDate}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "RASearch.ToDate",
                    })}
                    type="date"
                    valueRef={toDate}
                    setValue={setToDate}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={4}></Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "Invoice.Nr",
                    })}
                    type="text"
                    value={invoice}
                    setValue={setInvoice}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>
                <Grid item md={4}>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "RADetails.AddICT.ICTNr",
                    })}
                    type="text"
                    value={ict}
                    setValue={setIct}
                    inputCol={9}
                    textCol={3}
                  />
                </Grid>               
                <Grid item md={4}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isInError}
                          onChange={handleCheckBoxChange}
                        />
                      }
                      label={intl.formatMessage({
                        id: "FASTExtractions.InError",
                      })}
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </form>
          }
        />
      </Box>
      <Box id="form1" sx={{ mt: 2 }}>
        <Grid container>
          <Grid item lg={10}></Grid>
          <Grid item lg={2}>
            <Button
              variant="contained"
              sx={{ width: "100%" }}
              className="apeLigthBlueBackground"
              startIcon={<DownloadIcon />}
              onClick={handleRun}
            >
              {intl.formatMessage({ id: "ExcelReports.Run" })}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <DownloadExcelModal
        downloadLink={downloadLink}
        openDownloadModal={openDownloadModal}
      ></DownloadExcelModal>
    </Box>
  );
};

export default FASTExtractions;
